class NorthportClassReel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.slides = [...this.querySelectorAll('[data-reel-slide]')];
    this.stageButtons = [...this.querySelectorAll('[data-reel-stage]')];
    this.videos = [...this.querySelectorAll('[data-reel-video]')];
    this.controls = this.querySelector('[data-reel-controls]');
    this.toggleButton = this.querySelector('[data-reel-toggle]');
    this.status = this.querySelector('[data-reel-status]');
    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.activeIndex = 0;

    if (!this.slides.length) return;

    if (this.controls) this.controls.hidden = false;

    this.stageButtons.forEach((button) => {
      button.addEventListener('click', () => this.showStage(Number(button.dataset.reelStage), true));
    });

    this.videos.forEach((video, index) => {
      video.addEventListener('ended', () => this.showStage(Math.min(index + 1, this.slides.length - 1), true));
      video.addEventListener('play', () => this.syncToggle());
      video.addEventListener('pause', () => this.syncToggle());
    });

    this.toggleButton?.addEventListener('click', () => this.togglePlayback());
    this.syncMotionPreference = this.syncMotionPreference.bind(this);
    this.motionPreference.addEventListener('change', this.syncMotionPreference);
    this.syncMotionPreference();
  }

  disconnectedCallback() {
    this.motionPreference?.removeEventListener('change', this.syncMotionPreference);
    this.videos?.forEach((video) => video.pause());
  }

  syncMotionPreference() {
    if (this.motionPreference.matches) {
      this.showStage(this.slides.length - 1, false);
    } else {
      this.showStage(0, true);
    }
  }

  showStage(index, playVideo) {
    if (index < 0 || index >= this.slides.length) return;
    this.activeIndex = index;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    this.stageButtons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    this.videos.forEach((video) => video.pause());

    const activeSlide = this.slides[index];
    const activeVideo = activeSlide?.querySelector('[data-reel-video]');
    const stageLabel = activeSlide?.dataset.stageLabel || '';

    if (this.status) {
      this.status.textContent = `${stageLabel}, ${index + 1} of ${this.slides.length}`;
    }

    if (activeVideo && playVideo && !this.motionPreference.matches) {
      activeVideo.currentTime = 0;
      activeVideo.play().catch(() => this.syncToggle());
    }

    this.syncToggle();
  }

  togglePlayback() {
    if (this.motionPreference.matches) return;

    if (this.activeIndex === this.slides.length - 1) {
      this.showStage(0, true);
      return;
    }

    const activeVideo = this.slides[this.activeIndex]?.querySelector('[data-reel-video]');
    if (!activeVideo) {
      this.showStage(Math.min(this.activeIndex + 1, this.slides.length - 1), true);
      return;
    }

    if (activeVideo.paused) {
      activeVideo.play().catch(() => this.syncToggle());
    } else {
      activeVideo.pause();
    }
  }

  syncToggle() {
    if (!this.toggleButton) return;

    if (this.motionPreference.matches) {
      this.toggleButton.hidden = true;
      return;
    }

    this.toggleButton.hidden = false;

    if (this.activeIndex === this.slides.length - 1) {
      this.toggleButton.textContent = this.dataset.replayLabel;
      return;
    }

    const activeVideo = this.slides[this.activeIndex]?.querySelector('[data-reel-video]');
    if (!activeVideo) {
      this.toggleButton.textContent = this.dataset.nextLabel;
      return;
    }

    this.toggleButton.textContent = activeVideo.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
  }
}

if (!customElements.get('northport-class-reel')) {
  customElements.define('northport-class-reel', NorthportClassReel);
}
